import React from "react";
import { Router, Route } from "react-router-dom";
import { connect } from "react-redux";
import { history } from "../_helpers";
import { alertActions, professionalAction } from "../_actions";
import { PrivateRoute } from "../_components";
import { HomePage } from "../Pages/HomePage";
import { LoginPage } from "../Pages/LoginPage";
import { ProfessionalForm } from "../Pages/ProfessionalForm/ProfessionalForm";
import "antd/dist/antd.css";
import "./App.css";
import { AppUserLogin } from "../Pages/AppUserPage";
import { FindAccusedPage } from "../Pages/FindAccusedPage";
import { News } from "../Pages/News";
import { Notifications } from "../Pages/Notifications";
import { GPSInformation } from "../Pages/GPSInformation";
import { Wanted } from "../Pages/Wanted/Wanted";
import { Help } from "../Pages/Help/Help";
import { AboutUs } from "../Pages/AboutUs/AboutUs";
import { Reports } from "../Pages/Reports";
import { Reports3 } from "../Pages/Reports/Reports3";
import { Reports4 } from "../Pages/Reports/Reports4";
import { Profile } from "../Pages/Profile";
import { Dashboard } from "../Pages/Dashboard/Dashboard";
import { AboutCIMS } from "../Pages/AboutUsPage/AboutUsPaage";
import { CCTVLocation } from "../Pages/CCTVLocation";
import { Reports5 } from "../Pages/Reports/Reports5";

import { ReportSuperAdmin } from "../Pages/Reports/ReportSuperAdmin";
import { ReportSupReports4 } from "../Pages/Reports/ReportSupReport4";
import { ReportSupReports3 } from "../Pages/Reports/ReportSupReport3";
import { ReportPoliceSpotvise } from "../Pages/Reports/ReportPoliceSpotvise";
import { ReportAdminSpotvise } from "../Pages/Reports/ReportAdminSpotvise";
import { Plus2ReportAdmin } from "../Pages/Reports/Plus2ReportAdmin";
import { TwoPlus } from "../Pages/Reports/twoPlusComp";
import { IPLogs } from "../Pages/IPLogs/IPLogs";
import { Fuzzy } from "../Pages/SuperAdminTools/fuzzy";

import { SpotServellience } from "../Pages/SpotServellience/SpotServellience";
import { Samans } from "../Pages/samans";

import { CriminalView } from "../Pages/CriminalViewApp/CriminalView";

import { ArrestReportAdmin } from "../Pages/Reports/ArrestReportAdmin";
import { ReportPreventive } from "../Pages/Reports/ReportPreventive";
import { MainPage } from "../Pages/LoginPage/MainPage";
import MobileVerification from "../Pages/Verification/MobileVerification";
import { DocumentVerification } from "../Pages/Verification/DocumentVerification";
import { VerificationModule } from "../Pages/Verification/VerificationModule";
import { ActAndSection } from "../Pages/ActAndSection";

import { MapPoliceStation } from "../_components/MapPoliceStation";
import { PreventiveNotificationList } from "../Pages/Dashboard/PreventiveNotification";
import { WantedNotificationList } from "../Pages/Dashboard/WantedNotification";
import { GunaReportCom } from "../Pages/Reports/GunaComp";
import { AllocationGunaMege } from "../Pages/AllocationGunaMerge/AllocationGunaMege";
import { NoticeReport } from "../Pages/Reports/NoticeReport";
import { GangDetectionModule } from "../Pages/GangDetectionModule/allocationGangDetection";
import { AaropiShodha } from "../Pages/aaropi_shodha/aaropi_shodha";
import { AddCrimeFrom } from "../Pages/aaropi_shodha/newcrimeadd";
import { NCRReports } from "../Pages/Reports/NcrReport";
import { GangReport } from "../Pages/GangDetectionModule/gangDetails";
import UserPrivateRoute from "../_components/userPrivateGraph";
import { Modas } from "../Pages/Modasoperandi/modas";
import { GraphView } from "../Pages/GangDetectionModule/graphView";
import { FAQ } from "../Pages/FAQ/FAQ";
import { SuggestionFeedback } from "../Pages/FAQ/feedback";
import VendorApiTabs from "../Pages/API_Details/VedorAPiTab";
import { MapCities } from "../_components/mapCity";
import NewMainPage from "../Pages/LoginPage/NewMainPage";
import { SubCityFilter } from "../_components/subCity";
import apiLog from "../Pages/api_log/apiLog";
import { Logs } from "../Pages/logs/logs";
import PostmanCollection from "../Pages/postmanCollection/postmanCollection";
import ApiManager from "../Pages/API_Details/ApiManager";
import { GangSearch } from "../Pages/GangDetectionModule/gangSearch";
import { DailyReports } from "../Pages/Reports/dailyReports";
import { NewDashboard } from "../Pages/Dashboard/newDashboard";
import { AdminNewDashboard } from "../Pages/Dashboard/adminNewDashboard";
import { FaceSearchAllocation } from "../Pages/Face_Search/faceSearchAllocation";
import { FindFaceSearch } from "../Pages/Face_Search/findFaceSearch";
import { CountryStates } from "../Pages/SuperAdminTools/CountryStates";
import { CctnsDistricts } from "../Pages/SuperAdminTools/CctnsDistricts";
import { CctnsArrestReportCom } from "../Pages/Reports/CctnsArrestComp";
import { GunahaHideRequest } from "../Pages/SuperAdminTools/gunahaHideRequest";
import { CrimeNullList } from "../Pages/SuperAdminTools/crimeNullLIst";
import { douableCRCrimeList } from "../Pages/SuperAdminTools/douableCRCrimeList";
import { CctnsMissingList } from "../Pages/SuperAdminTools/cctnsMissing";
import { CctnsCity } from "../Pages/SuperAdminTools/mapCctnsCIty";
import { CcntsMissingReport } from "../Pages/Reports/cctnsMissingReport";
import { AropiCount } from "../Pages/Reports/aropiCount";
import { ImageMap } from "../Pages/image/imageMap";
import { ImageProvision } from "../Pages/image/imageProvision";

class App extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    history.listen((location, action) => {
      // clear alert on location change
      dispatch(alertActions.clear());
    });
  }

  componentDidMount() {
    //  comment for unwaned api called on login page
    // this.props.dispatch(professionalAction.getAllMaster());
    // this.props.dispatch(professionalAction.getCity());
    // this.props.dispatch(professionalAction.getDharm());
    // // this.props.dispatch(professionalAction.getKalam());
    // this.props.dispatch(professionalAction.getKayda());
    // this.props.dispatch(professionalAction.getCrimeType());
    // this.props.dispatch(professionalAction.getCrimeTitle());
    // this.props.dispatch(professionalAction.getStatus());

    console.log("process.env.REACT_APP_ENV", process.env.REACT_APP_ENV);
  }
  render() {
    const { alert, authentication } = this.props;
    //console.log(authentication)
    return (
      <Router history={history}>
        <div>
          <UserPrivateRoute exact path="/graph/:id" component={GraphView} />
          <PrivateRoute
            exact
            path="/"
            component={
              authentication &&
              authentication.user &&
              authentication.user.role === "2"
                ? Dashboard
                : Dashboard
            }
          />
          <PrivateRoute exact path="/AppUserLogin" component={AppUserLogin} />
          <PrivateRoute exact path="/finds" component={FindAccusedPage} />
          <PrivateRoute exact path="/News" component={News} />
          <PrivateRoute exact path="/users" component={HomePage} />
          <PrivateRoute exact path="/act-section" component={ActAndSection} />
          <PrivateRoute exact path="/Notifications" component={Notifications} />
          <PrivateRoute exact path="/wanted" component={Wanted} />
          <PrivateRoute exact path="/help" component={Help} />
          <PrivateRoute exact path="/aboutus" component={AboutUs} />
          <PrivateRoute
            exact
            path="/verification"
            component={VerificationModule}
          />
          <PrivateRoute
            exact
            path="/document-verification"
            // component={MobileVerification}
            component={DocumentVerification}
          />
          <PrivateRoute exact path="/aboutCIMS" component={AboutCIMS} />
          <PrivateRoute exact path="/profile" component={Profile} />
          <PrivateRoute exact path="/gps" component={GPSInformation} />
          <PrivateRoute exact path="/CCTVLocation" component={CCTVLocation} />
          <PrivateRoute
            exact
            path="/spotservellience"
            component={SpotServellience}
          />
          <PrivateRoute exact path="/reports" component={Reports} />
          <PrivateRoute exact path="/reports3" component={Reports3} />
          <PrivateRoute exact path="/reports4" component={Reports4} />
          {/* <PrivateRoute
            exact
            path="/ProfessionalForm"
            component={ProfessionalForm}
          /> */}
          <PrivateRoute
            exact
            path="/ProfessionalForm"
            component={AaropiShodha}
          />
          <PrivateRoute exact path="/add-crime" component={AddCrimeFrom} />
          <PrivateRoute exact path="/reports5" component={Reports5} />
          <PrivateRoute
            exact
            path="/reportAppUsers"
            component={ReportSuperAdmin}
          />
          <PrivateRoute
            exact
            path="/reportSupReport4"
            component={ReportSupReports4}
          />
          <PrivateRoute
            exact
            path="/reportSupReport3"
            component={ReportSupReports3}
          />
          <PrivateRoute
            exact
            path="/reportPoliceSpotvise"
            component={ReportPoliceSpotvise}
          />
          <PrivateRoute
            exact
            path="/reportAdminSpotvise"
            component={ReportAdminSpotvise}
          />
          {/* <PrivateRoute
            exact
            path="/reportPlus2Report"
            component={Plus2ReportAdmin}
          /> */}
          <PrivateRoute exact path="/reportPlus2Report" component={TwoPlus} />

          <PrivateRoute
            exact
            path="/reportArrest"
            component={CctnsArrestReportCom}
          />
          <PrivateRoute
            exact
            path="/reportPreventive"
            component={ReportPreventive}
          />
          <PrivateRoute exact path="/faq" component={FAQ} />
          <PrivateRoute exact path="/login_details" component={IPLogs} />
          <PrivateRoute exact path="/samans" component={Samans} />
          <PrivateRoute
            exact
            path="/map-police-station"
            component={MapPoliceStation}
          />
          <PrivateRoute exact path="/map-cities" component={MapCities} />
          <PrivateRoute
            exact
            path="/preventive-notification"
            component={PreventiveNotificationList}
          />
          <PrivateRoute
            exact
            path="/wanted-notification"
            component={WantedNotificationList}
          />
          <PrivateRoute exact path="/guna-report" component={GunaReportCom} />
          <PrivateRoute exact path="/notice-report" component={NoticeReport} />
          <PrivateRoute exact path="/sub-cities" component={SubCityFilter} />
          {/* old ui */}
          {/* <Route path="/login" component={MainPage} /> */}
          {/* new ui  */}
          <Route path="/login" component={NewMainPage} />
          <Route path="/criminal_view/:id" component={CriminalView} />
          <PrivateRoute
            exact
            path="/allocation-guna-merge"
            component={AllocationGunaMege}
          />
          <PrivateRoute
            exact
            path="/gang-detection"
            component={GangDetectionModule}
          />
          <PrivateRoute exact path="/gang-search" component={GangSearch} />
          <PrivateRoute exact path="/gang-details" component={GangReport} />
          <PrivateRoute exact path="/ncr" component={NCRReports} />
          <PrivateRoute exact path="/modas" component={Modas} />
          <PrivateRoute
            exact
            path="/suggestion-feedback"
            component={SuggestionFeedback}
          />
          <PrivateRoute exact path="/api-details" component={VendorApiTabs} />
          <PrivateRoute exact path="/api-log" component={apiLog} />
          <PrivateRoute exact path="/logs" component={Logs} />
          <PrivateRoute
            exact
            path="/postman-collection"
            component={PostmanCollection}
          />
          <PrivateRoute exact path="/api-manager" component={ApiManager} />
          <PrivateRoute exact path="/daily-repots" component={DailyReports} />
          <PrivateRoute exact path="/new-dashboard" component={NewDashboard} />
          <PrivateRoute
            exact
            path="/admin-new-dashboard"
            component={AdminNewDashboard}
          />
          <PrivateRoute
            exact
            path="/face-search-allocation"
            component={FaceSearchAllocation}
          />
          <PrivateRoute
            exact
            path="/find-face-search"
            component={FindFaceSearch}
          />
          <PrivateRoute exact path="/states" component={CountryStates} />
          <PrivateRoute
            exact
            path="/cctns-districts-map"
            component={CctnsDistricts}
          />
          <PrivateRoute exact path="/guna-hide" component={GunahaHideRequest} />
          <PrivateRoute exact path="/fuzzy" component={Fuzzy} />
          <PrivateRoute exact path="/crime-null" component={CrimeNullList} />
          <PrivateRoute
            exact
            path="/douable-cr"
            component={douableCRCrimeList}
          />
          <PrivateRoute
            exact
            path="/cctns-missing"
            component={CctnsMissingList}
          />
          <PrivateRoute exact path="/cctns-cities-map" component={CctnsCity} />
          <PrivateRoute
            exact
            path="/cctns-missing-report"
            component={CcntsMissingReport}
          />
          <PrivateRoute exact path="/aropi-count" component={AropiCount} />
          <PrivateRoute exact path="/image-map" component={ImageMap} />
          <PrivateRoute
            exact
            path="/image-provision"
            component={ImageProvision}
          />
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { alert, authentication, professionals } = state;
  return {
    alert,
    authentication,
    professionals,
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
